import React, { useContext, useEffect } from 'react';
import MobileSearchBar from '../MobileSearchBar';
import DesktopSearchBar from '../DesktopSearchBar';
import SEARCH_WIDGET_UTILS from './utils/utils';
import { searchWidgetContextType } from '../../../reducers/searchWidgetReducer';
import { SingleTrainClass } from '../../route_info/TrainClasses';

type SearchWidgetProps = {
  openDatePickerOnMount?: boolean;
  topFix?: boolean;
  modifySearchProps?: boolean;
  pageWiseContext: any;
  templateId?: any;
  searchButtonTitle?: string;
  onMountInitSearchWidget?: () => void;
  classNode?: SingleTrainClass;
  pageName?: string;
};

export const SearchWidget = ({
  openDatePickerOnMount = false,
  topFix = true,
  modifySearchProps = false,
  pageWiseContext,
  templateId,
  searchButtonTitle,
  onMountInitSearchWidget,
  classNode,
  pageName
}: SearchWidgetProps) => {
  const context = useContext<searchWidgetContextType>(pageWiseContext);
  const {
    searchWidgetState: { isCalendarOpen, fromFilter, toFilter, trainNumber, toCityNameUsed, fromCityNameUsed },
    searchWidgetDispatch
  } = context;
  const { closeCalendar, openCalendar, setFromCity, setToCity } =
    SEARCH_WIDGET_UTILS.SEARCH_COMPONENT_UTILS(searchWidgetDispatch);
  useEffect(() => {
    onMountInitSearchWidget && onMountInitSearchWidget();
  }, []);
  return (
    <React.Fragment>
      <MobileSearchBar
        fromStationNode={fromFilter}
        toStationNode={toFilter}
        closeCalendar={closeCalendar}
        openCalendar={openCalendar}
        setFromCity={setFromCity}
        setToCity={setToCity}
        isCalendarOpen={isCalendarOpen}
        trainNumber={trainNumber}
        templateId={templateId}
        searchButtonTitle={searchButtonTitle}
        modifySearchProps={modifySearchProps}
        pageName={pageName}
      />
      <DesktopSearchBar
        fromStationNode={fromFilter}
        toStationNode={toFilter}
        closeCalendar={closeCalendar}
        openCalendar={openCalendar}
        setToCity={setToCity}
        setFromCity={setFromCity}
        isCalendarOpen={isCalendarOpen}
        trainNumber={trainNumber}
        openDatePickerOnMount={openDatePickerOnMount}
        topFix={topFix}
        sourceCityEn={fromCityNameUsed}
        destinationCityEn={toCityNameUsed}
        classNode={classNode}
        pageName={pageName}
      />
    </React.Fragment>
  );
};

export default SearchWidget;
